export interface FollowupRecommendation {
  pill: string;
  prompt: string;
}

export interface FollowupRecommendations {
  followups: FollowupRecommendation[];
}

const RECS_REGEX = /```vsly\/json\/recs\n([\s\S]*?)\n```/;

export function extractRecommendations(
  content: string,
): FollowupRecommendation[] | null {
  if (!content) return null;
  const match = content.match(RECS_REGEX);
  if (match && match[1]) {
    try {
      const data = JSON.parse(match[1]) as FollowupRecommendations;
      if (Array.isArray(data.followups)) {
        return data.followups;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Failed to parse recommendations JSON`, e);
    }
  }
  return null;
}
